module.exports = __webpack_public_path__ + "static/media/2.7f606168.jpg";